import { atom } from 'jotai'

export const stateAtom = atom({ sending: false })
